import styled from '@emotion/styled';
import { Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export const StyledBoxPerson = styled.div<{
  left: number;
  width: number;
  time: number;
  delayTime: number;
  top: number;
}>`
  position: absolute;
  left: -${props => props.left}px;
  width: ${props => props.width}px;
  top: ${props => props.top}px;

  @keyframes bannerMovePerson {
    0% {
      left: ${props => `-${props.left}px`};
    }
    100% {
      left: 100%;
    }
  }
  animation: bannerMovePerson ${props => props.time}s linear
    ${props => props.delayTime}s infinite;
`;

const StyledFade = styled(Box)`
  &:before {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 0,
      rgba(255, 255, 255, 0) 100%
    );
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 150px;
    height: 100%;
    border-collapse: separate;
    z-index: 100;
  }
  &:after {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 1) 80%
    );
    overflow: hidden;
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    width: 150px;
    height: 100%;
    border-collapse: separate;
  }
`;

const SlideDesktopAndTablet: React.FC = () => (
  <Box w="100%" h="500px" position="relative">
    <Box
      bg="neutral.0"
      position="absolute"
      left="-40px"
      top={0}
      w="42px"
      zIndex={200}
      h="100%"
    />
    <StyledFade
      w="100%"
      justifyContent="center"
      alignItems="center"
      position="relative"
      h="100%"
      overflow="hidden"
    >
      <StaticImage
        quality={100}
        placeholder="blurred"
        style={{ maxHeight: 370, minWidth: 370 }}
        width={370}
        height={370}
        alt="vector"
        src="../../../assets/images/home_page_trusted_vector.png"
      />
      <StyledBoxPerson left={70} top={190} width={70} delayTime={0} time={14}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_5.png"
        />
      </StyledBoxPerson>
      <StyledBoxPerson left={145} top={330} width={145} delayTime={3} time={14}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_3.png"
        />
      </StyledBoxPerson>
      <StyledBoxPerson left={120} top={102} width={120} delayTime={4} time={14}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_6.png"
        />
      </StyledBoxPerson>
      <StyledBoxPerson
        left={200}
        top={240}
        width={200}
        delayTime={8.5}
        time={14}
      >
        <StaticImage
          quality={100}
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_4.png"
        />
      </StyledBoxPerson>
      <StyledBoxPerson left={110} top={25} width={110} delayTime={9} time={14}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_7.png"
          objectFit="contain"
        />
      </StyledBoxPerson>
      <StyledBoxPerson left={90} top={125} width={90} delayTime={11} time={14}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_2.png"
          objectFit="contain"
        />
      </StyledBoxPerson>
      <StyledBoxPerson
        left={90}
        top={330}
        width={90}
        delayTime={10.8}
        time={14}
      >
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_1.png"
          objectFit="contain"
        />
      </StyledBoxPerson>
      <StyledBoxPerson left={120} top={448} width={120} delayTime={6} time={10}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="logo"
          src="../../../assets/images/valspar_logo.png"
          width={120}
          height={38}
        />
      </StyledBoxPerson>
      <StyledBoxPerson left={140} top={125} width={140} delayTime={8} time={10}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="logo"
          src="../../../assets/images/dabella_logo.png"
          height={40}
        />
      </StyledBoxPerson>
      <StyledBoxPerson
        left={140}
        top={270}
        width={140}
        delayTime={10}
        time={10}
      >
        <StaticImage
          quality={100}
          placeholder="blurred"
          height={50}
          alt="vector"
          src="../../../assets/images/reneval_by_andersen_logo.png"
        />
      </StyledBoxPerson>
      <StyledBoxPerson
        left={200}
        top={160}
        width={200}
        delayTime={14}
        time={10}
      >
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="vector"
          src="../../../assets/images/certainteed_logo.png"
          height={40}
        />
      </StyledBoxPerson>
      <StyledBoxPerson
        left={200}
        top={350}
        width={200}
        delayTime={13}
        time={10}
      >
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="vector"
          src="../../../assets/images/james_hardie_logo.png"
          height={40}
        />
      </StyledBoxPerson>
    </StyledFade>
    <Box
      bg="neutral.0"
      position="absolute"
      right="-40px"
      top={0}
      w="42px"
      zIndex={200}
      h="100%"
    />
  </Box>
);

export default SlideDesktopAndTablet;
